import http from "@/http/aisea/axios_v2";
const resource = "/enterprises/crews/onboarding";
import qs from "qs";

/**
 * (V2) 乗船中船員一覧取得API
 * 
 * @param {Object} params - 以下の条件でデータを絞り込めます。
 * details:
 *   - CREW_AVAILABLE_ROLE
 *   - CREW_LICENSE
 *   - CREW_RESPONSIBILITY
 * manning_vessel_details:
 *   - MANNING_VESSEL_CREW_ROLE
 *   - MANNING_VESSEL_CREW_UPDATE_HISTORY
 */
export default {
  fetch(params) {
    return http.get(`${resource}`, {
      params: params,
      paramsSerializer: params => {
        return qs.stringify(params, { arrayFormat: "repeat" });
      },      
    });
  },
};
